// Expose regenerator runtime so that 3rd party libraries can access it via window
// TODO Find out why it's not already exposed
import runtime from 'regenerator-runtime/runtime'

window.regeneratorRuntime = runtime
